
const URL=process.env.REACT_APP_GEOTOLK_API

export const postBorehole = async (project_id, srid, borehole, token) => {
  const url = `${URL}/soilclassification/project/${project_id}/boreholes?srid=${srid}`;

  const data = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(borehole),
  });

  return data.json();
};

export const deleteBorehole = async (project_id, location_id, token) => {
  const url = `${URL}/soilclassification/project/${project_id}/boreholes/${location_id}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error(`User need to be admin to delete on project ${project_id}`);
  }

  return response.json();
};


export const updateSoilprofile = async (project_id, location_id, tlk, token) => {
  const url = `${URL}/soilclassification/project/${project_id}/boreholes/${location_id}/soilprofile`;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tlk),
  });

  if (!response.ok) {
    throw new Error(`User not access to modify on project ${project_id}`);
  }

  return response.json();
};


export const patchSridToProject = async (project_id, srid, token) => {
  const url = `${URL}/soilclassification/project/${project_id}/crs?srid=${srid}`;
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      srid: srid,
    }),
  });

  if (!response.ok) {
    throw new Error(`User does not have access to modify project ${project_id}`);
  }

  return response.json();
};
